import { render, staticRenderFns } from "./popularity.vue?vue&type=template&id=5a89a9da"
import script from "./popularity.vue?vue&type=script&lang=js"
export * from "./popularity.vue?vue&type=script&lang=js"
import style0 from "./popularity.vue?vue&type=style&index=0&id=5a89a9da&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports